import React from "react";

import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import { ExtendedStringifyOptions, QueryParamProvider, transformSearchStringJsonSafe } from "use-query-params";

import { Application } from "./components/application";
import * as serviceWorker from "./service_worker";
import RootReducer, { persistedState } from "./store/root_reducer";
import rootSaga from "./store/root_saga";

import "./i18n";
import "./index.scss";
import "./ckeditor.css";
import "antd/dist/antd.css";
import "./moment_chartjs_adapter";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(RootReducer, persistedState(), composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);

const queryStringifyOptions: ExtendedStringifyOptions = {
  transformSearchString: transformSearchStringJsonSafe,
};

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <QueryParamProvider stringifyOptions={queryStringifyOptions} ReactRouterRoute={Route}>
        <Application />
      </QueryParamProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
